import { useNavigate } from 'react-router-dom'
import { PresentationLibrary } from '../components/PresentationLibrary'

/**
 * Presentation Library Page Component
 *
 * This page uses the PresentationLibrary component that fetches
 * presentations from the backend API (/api/presentation-library) with
 * role-based access control, plus displays local presentations.
 *
 * Features:
 * - Tag filter chips below search
 * - Responsive grid/list view
 * - Working navigation to /presentations/:id
 * - Auto-generated thumbnails from slide data
 */
export function Presentations() {
  const navigate = useNavigate()

  const handlePresentationClick = (id: string) => {
    navigate(`/presentations/${id}`)
  }

  return <PresentationLibrary onPresentationClick={handlePresentationClick} />
}
